<template>
  <main class="container-fluid p-0">
    <hero-video />
    <featured-channels />
    <div class="divider-line my-5 p-3 d-block"></div>
    <supported-devices />
    <div class="divider-line my-5 p-3 d-block"></div>
    <freemium-faq />
    <div class="divider-line my-5 p-3 d-block"></div>
    <be-part-of />
  </main>
</template>

<script>
import BePartOf from "../../components/landing/BePartOf.vue";

import { OrizonApiClient } from "@/services/OrizonApiClient";
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";
import HeroVideo from "@/components/landing/freemium/HeroVideo.vue";
import SupportedDevices from "@/components/landing/freemium/SupportedDevices.vue";
import FreemiumFaq from "@/components/landing/freemium/FreemiumFaq.vue";
import FeaturedChannels from "@/components/landing/freemium/FeaturedChannels.vue";
import { mapState } from "pinia";
import { SessionStore } from "@/stores/sessionStore";
const apiClient = new OrizonApiClient();

export default {
  name: "FreemiumView",
  metaInfo: () => {
    return {
      title: i18n.global.t("freemium.meta.title"),
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(i18n.global.t("freemium.meta.description")),
        MetaService.keywords(i18n.global.t("freemium.meta.keywords")),
      ],
    };
  },
  components: {
    FeaturedChannels,
    FreemiumFaq,
    SupportedDevices,
    HeroVideo,
    BePartOf,
  },
  data() {
    return {
      premieres: [],
      exclusives: [],
      actor: null,
    };
  },
  beforeUnmount() {
    console.info("unmounting home view");
    this.$bus.off("langChanged");
  },
  mounted() {
    this.fetchLanding();
    this.setFreemiumWorkflow(true);
    this.$bus.on("langChanged", () => {
      try {
        this.fetchLanding();
      } catch (e) {
        console.info("fetch landing", e.title);
      }
    });
    this.$meta.canonicalUrls(
      this.$t("routes.free", "es"),
      this.$t("routes.free", "en"),
      "/"
    );
  },
  methods: {
    fetchLanding: function () {
      apiClient.get("/landing").then((response) => {
        if (!response.data.error) {
          this.premieres = response.data.top;
          this.exclusives = response.data.mid;
          this.actor = response.data.actor;
        }
      });
    },
  },
  computed: {
    ...mapState(SessionStore, ["setFreemiumWorkflow"]),
  },
};
</script>
